import cloudtara from "../assets/images/cloudtara.jpg";
import curiousjr from "../assets/images/curiousjr.svg";
import popup from "../assets/images/popup.svg";
import tcs from "../assets/images/tcs.png";

const experiences = [
  {
    id: 1,
    companyName: "Tata Consultancy Services",
    companyImg: tcs,
    companyLink: "https://www.tcs.com/",
    description: "In my role as a Full-stack Developer at Tata Consultancy Services within the Robotics Smart Machines unit, I am actively engaged in the development of a sophisticated Fleet Management System, where I tackle complex challenges head-on, devising innovative solutions to ensure optimal performance and efficiency."
  },
  {
    id: 2,
    companyName: "Popup Inc.",
    companyImg: popup,
    companyLink: "https://www.popup.store/",
    description: "Developing the Popup platform and infrastructure. Deploying software tools, processes and metrics. Directing software programming and documentation development. Writing and implementing code, improving existing code."
  },
  {
    id: 3,
    companyName: "CuriousJr",
    companyImg: curiousjr,
    companyLink: "https://curiousjr.com/",
    description: "Creating apps in HTML5, CSS3 and Javascript for kids to help learn coding and create the app from scratch."
  },
  {
    id: 4,
    companyName: "Cloud Tara Technologies",
    companyImg: cloudtara,
    companyLink: "https://www.cloudtara.com",
    description: "Working and managing front-end application and integrating with back-end for full scale operation."
  }
];

export default experiences;